import { Component, ViewEncapsulation } from '@angular/core';
import { AuthService } from '@app/shared/services/auth.service';
import { environment } from '@env/environment';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-webshop-button',
  templateUrl: './webshop-button.component.html',
  styleUrls: ['./webshop-button.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class WebshopButtonComponent {
  constructor(
    public authService: AuthService,
    public translate: TranslateService,
  ) {}
  openWebShop() {
    window.open(environment.sensorWebShopUrl, '_blank');
  }
}
